import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/map'
import 'rxjs/Rx'

@Injectable({
  providedIn: 'root'
})
export class DhhpApiService {
  authHeaderOptions: any;
  constructor(private http: HttpClient, private authService:AuthService) { }
  catchError(err) {
    console.log(err);
    throw err;
  }
  getApi(url: string,cache = false):Observable<any> {
    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }else{
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return this.http.get(url, { headers:headers }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  getApiString(url: string,cache = false):Observable<any> {
    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }else{
      headers = new HttpHeaders({ 'Content-Type': 'text/plain' });
    }
    return this.http.get(url, {responseType: 'text' })
  }
  postApi(url: string, postValue: any,cache = false):Observable<any> {
    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }else{
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return this.http.post(url, postValue, { headers: headers }).pipe(
      map(res => {      
        return res = res;
      }),
      catchError(err => {         
        this.catchError(err); 
        return of(err.message) })
    );
  }
  imgPostApi(url: string, postValue: any) {
    return this.http.post(url, postValue).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  putApi(url: string, putValue: any,cache = false):Observable<any> {
    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }else{
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return this.http.put(url, putValue, { headers: headers }).pipe(
      map(res => {
        return res = res;
      }),
      catchError(err => { 
        this.catchError(err); 
        return of(err.message) })
    );
  }

  deleteApi(url: string):Observable<any> {
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

   private getImageHeaders(){
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'multipart/form-data;');
    return headers;  
   }

  // private appendAuthHeader(headers: HttpHeaders) {
  //   const token = '';
  //   if (token === '') return headers;
  //   const tokenValue = 'Bearer ' + token;
  //   return headers.set('Authorization', tokenValue);
  // }
}
